var React = require('react');

function Minus (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M2.5 8h11","stroke":"#262626","strokeWidth":"1.333","strokeLinecap":"round","strokeLinejoin":"round"}));
}

Minus.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none"};

module.exports = Minus;

Minus.default = Minus;
